module.exports = __webpack_public_path__ + "img/vessel_path.ca7fda6f.png";